import { register } from '!/repository'
import { api } from '@setplex/tria-api'
import { combine, createEvent, sample } from 'effector'
import { not } from 'patronum'
import { model as popupModel } from '~/entities/info-popup'
import { model as liveEventsModel } from '~/entities/live-events'
import { model as paymentModel } from '~/features/payment/generic'
import { ssePurchasesModel } from '~/features/payment/sse-purchases'
import { $eventsDetails, $paymentButtonText } from './translations'

export const initExactEventPage = createEvent<{
  eventId: number
  query: URLSearchParams
}>()

export const left = createEvent()

// CONNECTIONS
sample({
  clock: initExactEventPage,
  filter: not(liveEventsModel.loadLiveEventFx.pending),
  target: liveEventsModel.loadLiveEventFx,
})

const $liveEventFormatted = combine(
  liveEventsModel.$currentLiveEvent,
  ssePurchasesModel.$liveEvent,
  (liveEvent, adjust) => (liveEvent ? adjust(liveEvent) : null)
)

/******* reload event after countdown expires logic *******/
export const reloadEventOnTime = createEvent<{
  eventId: number
}>()

sample({
  clock: reloadEventOnTime,
  source: {
    liveEvent: liveEventsModel.$currentLiveEvent,
    isPendingStatus: liveEventsModel.loadLiveEventFx.pending,
  },
  filter: ({ liveEvent, isPendingStatus }) =>
    liveEvent?.id != null && !isPendingStatus,
  fn: ({ liveEvent }) => ({ eventId: liveEvent?.id as number }), // as number covered by filter
  target: liveEventsModel.loadLiveEventFx,
})
/******* reload event after countdown expires logic *******/

const selectLiveEventPaymentButton = createEvent<void>()

sample({
  clock: selectLiveEventPaymentButton,
  source: api.liveEvents.$liveEvent,
  filter: Boolean,
  target: paymentModel.selectLiveEventPaymentButton,
})

// clear store
liveEventsModel.$currentLiveEvent.reset(initExactEventPage)

sample({
  clock: initExactEventPage,
  target: popupModel.closeInfoPopup,
})

register(reloadEventOnTime, 'reloadEventOnTime')
register($liveEventFormatted, '$liveEventFormatted')
register(selectLiveEventPaymentButton, 'selectLiveEventPaymentButton')
register($eventsDetails, '$eventsDetails')
register($paymentButtonText, '$paymentButtonText')
